import pegasus from '../../build/global/js/00-pegasus';

window.siteFooter = () => {
    return {
        init(){
            const countryPicker = document.getElementById('countries');

            pegasus.selectField(countryPicker, {
                openOnHover: false,
                itemsToShow: 5,
                classNames: {
                    outerWrapper:   'no-arrow mt-4',
                    selector:       'map-pin pl-8 flex justify-between w-full cursor-pointer body-small transition duration-300 text-left focus:outline-none',
                    selectorOpen:   'md:mb-4',
                    selectionList:  'transition duration-500 w-full overflow-hidden bg-greyscale-white-01 border-t-0 rounded-lg p-4',
                    listItem:       'text-greyscale-white-06 body-small font-medium select-none relative py-3 border-t border-dashed border-greyscale-white-04 transition duration-300 hover:bg-greyscale-white-04 active:bg-greyscale-white-04 focus:bg-greyscale-white-04',
                    listItemFocus:  'bg-blue-100 text-black',
                }
            });
        },
        territorySelect(href)
        {
            window.location.href = href;
        }
    }
}